import React from "react"
import clsx from "clsx"
import SurveyFormFileUploadBuilder from "../../SurveyFormFileUploadBuilder/SurveyFormFileUploadBuilder";
import I18n from "i18n-js";


class DocumentFormPresenterAnswers extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'document_form_answers',
      'tab-pane': true
    });
    return (
      <div className={tabClasses} id='document_form_answers'>
        {this.renderFormFields(this.props.form_fields)}
      </div>
    )
  }

  renderFormFields(form_fields) {
    var formFields = form_fields.sort((a,b) => a.position - b.position).map((form_field) => {
      var form_field_answer = null
      var display_only_answer = null
      var image_answer = null

      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.sort((a, b) => a.position - b.position ).map((answer) => {
          if(answer.form_field_id == form_field.id){
            }if(answer.upload_file_name != null) {
              image_answer = answer      
            }else if(answer.agree_to != null) {
              display_only_answer = answer.agree_to
            } else {
              form_field_answer = answer.answer
            }
          })   
      }
    

      if(form_field.field_type == "display_only") {
        if(form_field.required == true) { 
          return (
            <div className="col-lg-10" key={form_field.id} id={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}*`}</label>
                <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
                <label style={display_only_answer == true ? {paddingTop:'5px', float:'right', fontFamily:'cursive'} : {paddingTop:'5px', float:'right'}}>
                  <input type="checkbox" name={form_field.field_type} checked disabled={display_only_answer == true ? true : false} id={form_field.id} onChange={this.onChangeFormFields} />
                  {` ${this.props.initials ? this.props.initials : I18n.t('agree')}`}
                </label>
              </div>
              <br></br>
              <hr></hr>
            </div>
          )
        } else {
          return (
            <div className="col-lg-10" key={form_field.id} id={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
              </div>
              <hr></hr>
            </div>
          )
        }
      }



      if(form_field.field_type == "signature_generator") {
        if(form_field_answer) {
          return (
            <div className="col-lg-10" key={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} readOnly={true}/>
                <br></br>
                <textarea className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control signature-generator has-errors" : "form-control signature-generator"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive'}} readOnly={true}/>
              </div>
            </div>
          )
        } else {
          return (
            <div className="col-lg-10" key={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.props.errors && this.props.errors.field_errors && this.props.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} readOnly={true} />
              </div>
            </div>
          )
        } 
      }

      if(form_field.field_type == "image") {
        if(image_answer != null) { 
          return (
            <div className="col-lg-10" key={form_field.id} style={{padding:'0'}}>
              <div className="form-group">
                <SurveyFormFileUploadBuilder nested={true} read_only={true} file_upload_groups={this.props.customer_file_upload_group ? [this.props.customer_file_upload_group] : [{ file_uploads: [image_answer] }]} singleFile={true} form_field_id={form_field.id} form_field={form_field} />
              </div>
            </div>   
          )
        } else {
          return (
            <div className="col-lg-10" key={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div><span className="none">{I18n.t('none')}</span></div>
              </div>
            </div> 
          )
        }
      }
    });

    return (
      <div className="form-group">
        <img src={this.props.logo_image_url} style={{width: 200, height: 'auto', paddingBottom: '10px', marginBlockStart: '20px'}}></img>
        <br />
        <h4>{this.props.title}</h4>
        <br/>
        <i>{this.props.description}</i>
        <hr/>
        {formFields}  
      </div>
    );
  }


}

export default DocumentFormPresenterAnswers